<template>
  <el-tabs v-model="activeName" type="card">
    <!-- <el-tab-pane label="下载日志" name="first"> -->
    <el-row>
      <el-col :span="24">
        <el-table
          :data="tableData1"
          tooltip-effect="dark"
          style="width: 100%; border-radius: 20px 20px 0 0; overflow: hidden"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
        >
          <el-table-column
            prop="DocumentName"
            align="center"
            label="文档名称"
          ></el-table-column>

          <el-table-column label="下载地址" align="center">
            <template slot-scope="scope">
              <el-button
                v-on:click="download(scope.row)"
                icon="el-icon-download"
              ></el-button>

            </template>
          </el-table-column>

        </el-table>
      </el-col>
      <el-col :span="24">
        <div style="float: right; margin-top: 20px">
          <el-pagination
            @current-change="handleCurrentChange1"
            background
            layout="prev, pager, next"
            :total="total1"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- </el-tab-pane> -->
    <!--		<el-tab-pane label="Multi Table" name="second">-->
    <!--			<el-row>-->
    <!--				<el-col :span="24">-->
    <!--					<el-table ref="multipleTable" :data="tableData2" tooltip-effect="dark" style="width: 100%">-->
    <!--						<el-table-column prop="sFileName" label="File Name"></el-table-column>-->
    <!--						<el-table-column prop="dTime" label="Time"></el-table-column>-->
    <!--						<el-table-column prop="sStatus" label="Status" :formatter="sStatus"></el-table-column>-->
    <!--						<el-table-column label="DownLoad">-->
    <!--							<template slot-scope="scope">-->
    <!--								<el-button v-if="scope.row.sStatus == 1" v-on:click="download(scope.row)" icon="el-icon-download"></el-button>-->
    <!--								<el-button v-if="scope.row.sStatus == 0" style="border:none;" icon="el-icon-loading"></el-button>-->
    <!--								<el-button v-if="scope.row.sStatus == 2" v-on:click="refresh(scope.row)" icon="el-icon-refresh"></el-button>-->
    <!--							</template>-->
    <!--						</el-table-column>-->
    <!--						<el-table-column label="Favorite">-->
    <!--							<template slot-scope="scope">-->
    <!--								<el-button v-if="scope.row.sFavorite==1" icon="el-icon-star-on"></el-button>-->
    <!--								<el-button v-on:click="favorite(scope.row,'2')" v-if="scope.row.sFavorite==0" icon="el-icon-star-off"></el-button>-->
    <!--							</template>-->
    <!--						</el-table-column>-->
    <!--					</el-table>-->
    <!--				</el-col>-->
    <!--				<el-col :span="24">-->
    <!--					<div style="float: right;margin-top:20px;">-->
    <!--						<el-pagination @current-change="handleCurrentChange2" background layout="prev, pager, next" :total="total2"></el-pagination>-->
    <!--					</div>-->
    <!--				</el-col>-->
    <!--			</el-row>-->
    <!--		</el-tab-pane>-->
    <!--		<el-tab-pane label="Stored Procedure" name="third">-->
    <!--			<el-row>-->
    <!--				<el-col :span="24">-->
    <!--					<el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%">-->
    <!--						<el-table-column prop="sFileName" label="File Name"></el-table-column>-->
    <!--						<el-table-column prop="dTime" label="Time"></el-table-column>-->
    <!--						<el-table-column prop="sStatus" label="Status" :formatter="sStatus"></el-table-column>-->
    <!--						<el-table-column label="DownLoad">-->
    <!--							<template slot-scope="scope">-->
    <!--								<el-button v-if="scope.row.sStatus == 1" v-on:click="download(scope.row)" icon="el-icon-download"></el-button>-->
    <!--								<el-button v-if="scope.row.sStatus == 0" style="border:none;" icon="el-icon-loading"></el-button>-->
    <!--								<el-button v-if="scope.row.sStatus == 2" v-on:click="refresh(scope.row)" icon="el-icon-refresh"></el-button>-->
    <!--							</template>-->
    <!--						</el-table-column>-->
    <!--						<el-table-column label="Favorite">-->
    <!--							<template slot-scope="scope">-->
    <!--								<el-button v-if="scope.row.sFavorite==1" icon="el-icon-star-on"></el-button>-->
    <!--								<el-button v-on:click="favorite(scope.row,'3')" v-if="scope.row.sFavorite==0" icon="el-icon-star-off"></el-button>-->
    <!--							</template>-->
    <!--						</el-table-column>-->
    <!--					</el-table>-->
    <!--				</el-col>-->
    <!--				<el-col :span="24">-->
    <!--					<div style="float: right;margin-top:20px;">-->
    <!--						<el-pagination @current-change="handleCurrentChange3" background layout="prev, pager, next" :total="total3"></el-pagination>-->
    <!--					</div>-->
    <!--				</el-col>-->
    <!--			</el-row>-->
    <!--		</el-tab-pane>-->
  </el-tabs>
</template>

<script>
import {
  getDownloadExportList,
  reloadDownloadExport,
  updateFavorite,
  addSelectView, getDynamicSQL,
} from "../../api/api";
export default {
  data() {
    return {
      activeName: "first",
      filter1: {
        nType: 1,
        pageSize: 10,
        currentPage: 1,
      },
      filter2: {
        nType: 2,
        pageSize: 10,
        currentPage: 1,
      },
      filter3: {
        nType: 3,
        pageSize: 10,
        currentPage: 1,
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      total1: 0,
      total2: 0,
      total3: 0,
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px",
      },
      cellStyle: {
        height: "55px",
      },
    };
  },
  mounted() {
    this.getList1();
  },
  methods: {

    download(data) {
      window.open( "helpDoc/" +data['Address'], "_blank");
    },
    handleCurrentChange1(val) {
      this.filter1.currentPage = val;
      this.getList1();
    },

    getList1: function () {
      var param = Object.assign(
          {
            sSelectName: "Prompt_List",
            sSelectFieldName: "DocumentName,Address",
            extBody: 1,
            sSchemaName: "business_data.dbo",
          },
          this.filter1
      );
      getDynamicSQL(param).then((res) => {
        this.tableData1 = res.data;
        this.total1 = res.page.totalCount * 1;
      });
    }  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// help.vue?946e77f4